import { UIState } from "./UIProvider";


//* Aqui definiremos cada acción.
type UIActionType = 
  | { type: '[UI] - TOOGLE SIDE MENU' }
  | { type: '[UI] - TOOGLE SIDER COLLAPSED' }
  | { type: '[UI] - SET IS LOADING', payload: boolean }
  | { type: '[UI] - SHOW ERROR', payload: boolean }
  | { type: '[UI] - MENU SELECT', payload: any }

export const uiReducer = ( state: UIState, action: UIActionType ): UIState => {
  switch (action.type) {
    case '[UI] - TOOGLE SIDE MENU':
      return {
        ...state,
        isSideMenuOpen: !state.isSideMenuOpen,
      };

    case '[UI] - TOOGLE SIDER COLLAPSED':
      return {
        ...state,
        isSiderCollapsed: !state.isSiderCollapsed,
      };

    case '[UI] - SET IS LOADING':
      return {
        ...state,
        isLoading: action.payload,
      };

    case '[UI] - SHOW ERROR':
      return {
        ...state,
        showError: action.payload,
      };

    case '[UI] - MENU SELECT':
      return {
        ...state,
        menuSelect: action.payload,
      };

    default:
      return state;
  }
};